module.exports = __webpack_public_path__ + "static/media/logo-long.b916f74a.png";